import { useState, useMemo } from 'react'

import { GroupsChannelFormattedRowType } from './useGroupsChannelsFormattedRows'
import { GroupsSiteFormattedRowType } from './useGroupsSitesFormattedRows'

export const useGroupsSearch = <
    T extends GroupsChannelFormattedRowType | GroupsSiteFormattedRowType,
>(
    data: T[]
) => {
    const [searchQuery, setSearchQuery] = useState('')

    const filteredData = useMemo(() => {
        if (!searchQuery) return data
        return data.filter((item) => {
            const nameMatch =
                item.groupName &&
                item.groupName.toLowerCase().includes(searchQuery.toLowerCase())
            const budgetMatch =
                item.budget && item.budget.toString().includes(searchQuery)
            const dateMatch =
                item.creationDate &&
                new Date(item.creationDate)
                    .toLocaleDateString('ru-RU')
                    .includes(searchQuery)
            return nameMatch || budgetMatch || dateMatch
        })
    }, [data, searchQuery])

    return { searchQuery, setSearchQuery, filteredData }
}
